import { fetchEventSource } from "@microsoft/fetch-event-source";
import { hasPermission } from "../Components/Utils/UtilityFunctions";
import { store } from "../index";

let abortController = null;
let isConnected = false;

export const startSSE = (token, onMessage) => {
  if (!token) {
    console.log("SSE: No token available");
    return;
  }

  if (isConnected) {
    console.log("SSE already connected");
    return;
  }

  if (abortController) {
    console.log("Closing existing SSE connection");
    abortController.abort();
  }

  abortController = new AbortController();

  const url = `${window.env.REACT_APP_BASE_URL}/notifications-sse`;

  console.log("SSE URL:", url);

  const roleName = localStorage.getItem("roleName");
  const rawPermissions = store.getState().permissions.permissionsMap;
    
  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const notificationsPermission = hasPermission(permissionsMap, "monitoringandcontrol", "notifications");
  notificationsPermission && fetchEventSource(url, {
    method: "GET",

    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "text/event-stream",
      userId: localStorage.getItem("userName") || "",
    },

    signal: abortController.signal,

    // Keep connection alive even when tab is inactive
    openWhenHidden: true,

    async onopen(response) {
      console.log("SSE Status:", response.status);

      if (!response.ok) {
        isConnected = false;
        throw new Error(
          `SSE Connection Failed: ${response.status}`
        );
      }

      isConnected = true;
      console.log("SSE Connected");
    },

    onmessage(event) {
      try {
        // Ignore heartbeat comments/empty messages
        if (!event.data) return;

        const data = JSON.parse(event.data);

        console.log("SSE Message:", data);

        onMessage?.(data);
      } catch (err) {
        console.error("SSE Parse Error:", err);
      }
    },

    onclose() {
      console.log("SSE Closed by server");
      isConnected = false;
    },

    onerror(error) {
      isConnected = false;

      if (error?.name === "AbortError") {
        console.log("SSE Aborted");
        return;
      }

      console.error("SSE Error:", error);

      // Allow fetch-event-source to retry
      throw error;
    },
  }).catch((error) => {
    console.error("SSE Fetch Failed:", error);
    isConnected = false;
  });
};

export const stopSSE = () => {
  console.log("Stopping SSE");

  if (abortController) {
    abortController.abort();
    abortController = null;
  }

  isConnected = false;
};